import * as yup from "yup";
import { validationSchemas } from "./data";
export const loginSchema = yup.object().shape({
  username: validationSchemas.name,
  password: validationSchemas.name,
});
